import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/common/Navbar.js';
import Footer from './components/common/Footer.js';
import Home from './pages/Home';
import Autism from './pages/Autism.js';
import KidsSMASS from './pages/KidsSMASS';
import AboutUs from './pages/AboutUs';
import SelectiveMutism from './pages/SelectiveMutism.js';
import Impressum from './pages/Impressum.js';
import Privacy from './pages/Privacy.js';
import Participate from './pages/Participate.js';


const AppRoutes = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/selective-mutism" element={<SelectiveMutism />} />
        <Route path="/autism" element={<Autism />} />
        <Route path="/kids-sm-ass" element={<KidsSMASS />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/participate" element={<Participate />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default AppRoutes;
